function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M414.9,388a27.9,27.9,0,1,0,27.9,27.9A27.934,27.934,0,0,0,414.9,388Zm0,52.235A24.334,24.334,0,1,1,439.236,415.9,24.361,24.361,0,0,1,414.9,440.235Zm0,0",
  transform: "translate(-387 -388)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.219,440.261a9.359,9.359,0,0,0-9.348,9.349,1.784,1.784,0,0,0,3.568,0,5.78,5.78,0,1,1,5.78,5.78,1.784,1.784,0,0,0-1.784,1.784v6.859a1.785,1.785,0,1,0,3.569,0v-5.246a9.349,9.349,0,0,0-1.785-18.527Zm0,0",
  transform: "translate(-443.317 -427.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494.179,554.531a1.784,1.784,0,1,0,1.261.522,1.8,1.8,0,0,0-1.261-.522Zm0,0",
  transform: "translate(-466.277 -513.263)",
  fill: "#fff"
}));

function SvgFaqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.804,
    height: 55.804,
    viewBox: "0 0 55.804 55.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.5f5d3f87.svg";
export { ForwardRef as ReactComponent };